/* eslint-disable @typescript-eslint/no-unused-vars */
import Swal from 'sweetalert2';
import { API_URL } from '../config';
import { decryptData } from './enode-decode';

export const decodeHexResponse = (response: any, key: string) => {
	// Check if response and response.response exist
	if (!response || !response.response) {
		console.error('decodeHexResponse: Invalid response structure:', response);
		return null;
	}

	const docodeVal = decryptData(response.response, key);
	console.log('decodeHexResponse result:', docodeVal);
	// Return null if decryption failed
	if (docodeVal === null) {
		console.error('decodeHexResponse: Failed to decrypt response');
		return null;
	}
	return docodeVal;
};

// Upload logo file first if selected
export const uploadImage = async (
	selectedFile: any,
	employeeID: any,
	certificateType: any,
): Promise<string | null> => {
	if (!selectedFile) return null;

	const uploadFormData = new FormData();
	uploadFormData.append('file', selectedFile);
	uploadFormData.append('certificateType', certificateType);
	if (employeeID) {
		uploadFormData.append('employeeID', employeeID);
	}

	try {
		const response = await fetch(`${API_URL}upload.php`, {
			method: 'POST',
			body: uploadFormData,
		});

		const responseText = await response.text();
		let result;

		try {
			result = JSON.parse(responseText);
		} catch (parseError) {
			if (responseText.includes('success')) {
				result = { status: 'success' };
			} else {
				throw new Error('Invalid server response');
			}
		}

		if (result.status === 'success') {
			return result.filePath || null;
		}
		throw new Error(result.message || 'Logo upload failed');
	} catch (error: any) {
		console.error('Logo upload error:', error);
		Swal.fire({
			title: 'Upload Error',
			text: error.message || 'Failed to upload logo',
			icon: 'error',
			confirmButtonText: 'OK',
		});
		return null;
	}
};
